module.exports = __webpack_public_path__ + "img/214.549df1e4.jpg";